import { observer } from 'mobx-react-lite'
import React, { Fragment, useMemo } from 'react'
import Switch from '../../../../../FormComponents/Switch'
import Textarea from '../../../../../FormComponents/Textarea'

export default observer(function DefaultSection({ values, title, handleBlur, handleChange, setFieldValue }) {
  const index = useMemo(() => values.default_campaign_overview_sections_attributes.findIndex(section => section.title === title), [values.default_campaign_overview_sections_attributes, values.default_campaign_overview_sections_attributes.length])

  return (
    <Fragment>
      <div className="flex justify-between items-center my-8">
        <p className="font-bold dark:text-white">{title}</p>
        <Switch name="campaign_overview_visible" value={values.default_campaign_overview_sections_attributes[index]?.visible} onChange={({ target: { checked }}) => setFieldValue(`default_campaign_overview_sections_attributes.${index}.visible`, checked, true)} eyeSwitch />
      </div>
      <Textarea
        className={`rounded-lg px-4 w-full ${!values.default_campaign_overview_sections_attributes[index]?.visible && 'bg-gray-100 dark:bg-rb-dark-mode-lighter'}`}
        rows={4}
        label="Free text"
        placeholder="Write something here"
        name={`default_campaign_overview_sections_attributes.${index}.free_text`}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={!values.default_campaign_overview_sections_attributes[index]?.visible}
        value={values.default_campaign_overview_sections_attributes[index]?.free_text}
      />
      <div className="border-1 w-full border-gray-100 dark:border-rb-dark-mode-lighter" />
    </Fragment>
  )
})